// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { getListFile, uploadMultipleFileAndGetLink } from './fileThunk';

export interface IFileState {
  isRefreshFileList: boolean;
}

export const initialState: IFileState = {
  isRefreshFileList: false,
};

const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    setRefreshFileList(state, action) {
      state.isRefreshFileList = action.payload;
    },
  },
  extraReducers(builder) {
    // POST: Upload multiple file and get link
    builder
      .addCase(uploadMultipleFileAndGetLink.pending, (state) => {})
      .addCase(uploadMultipleFileAndGetLink.fulfilled, (state) => {})
      .addCase(uploadMultipleFileAndGetLink.rejected, (state) => {});

    // GET: Get list File
    builder
      .addCase(getListFile.pending, (state) => {})
      .addCase(getListFile.fulfilled, (state) => {})
      .addCase(getListFile.rejected, (state) => {});
  },
});

// Action
export const fileActions = fileSlice.actions;

// Selectors
export const selectIsRefreshFileList = (state: RootState) => state.file.isRefreshFileList;

// Reducer
const fileReducer = fileSlice.reducer;
export default fileReducer;
